// Native
import { Component, Input, OnInit } from '@angular/core';

// Interfaces

// Services
import { CardService } from "./card.service";

@Component({
  selector: 'card',
  templateUrl: './card.component.html',
  providers: [CardService]
})
export class CardComponent implements OnInit {

  @Input() name: string;            // Заголовок карточки
  @Input() subName: string;         // Дополнительная информация в заголовке (стилизация)
  @Input() divider: boolean;        // Черта резделения между header и body
  @Input() header: boolean = true;  // Отображает header в разметке
  @Input() cardClass: string;       // Классы к карточке

  /*
  'full' - растягивает карточку по высоте
  'full-inner' - анологичен 'full', но растягивает еще и контент
  'normal' - обычное поведение
   */
  @Input() height: 'full' | 'full-inner' | 'normal' = 'normal';
  @Input() empty: boolean = false;                 // Состояние отображения вывода пустых данных
  @Input() error: boolean = false;                 // Состояние отображения вывода ошибки
  @Input() without: boolean = false;               // Состояние отображения вывода без данных

  constructor(public cardService: CardService) { }

  ngOnInit() {
  }

}
